module.exports = __webpack_public_path__ + "3e6735559e6342a3ebd17ce4b816968c.svg";